import React from 'react';
import { useSelector } from 'react-redux';
import { useTrackAssetContext } from '../../components/TrackAsset';
import FramingTimelineHandle, {
  FramingTimelineHandleProps,
} from './FramingTimelineHandle';
import { createLayoutTimelineSegmentIdsSelector } from './selectors';

export type FramingAdjustmentHandlesProps = Pick<
  FramingTimelineHandleProps,
  'onDragStart' | 'onDragStop'
>;

/**
 * The framing adjustment handles aren't actually rendered between each segment,
 * but rather use absolute positoining to place themselves between the segments.
 *
 * Changing the position of a handle will adjust that handle's position as well as
 * the start times of the surrounding segments.
 */
export default function FramingAdjustmentHandles({
  onDragStart,
  onDragStop,
}: FramingAdjustmentHandlesProps) {
  const { id: videoId } = useTrackAssetContext();
  const timeline = useSelector(createLayoutTimelineSegmentIdsSelector(videoId));

  return (
    <>
      {timeline.reduce((elements, segmentId, index) => {
        const idBase = `segment-${segmentId}-handle`;
        const leftHandleId = `${idBase}-left`;
        const rightHandleId = `${idBase}-right`;

        elements.push(
          <FramingTimelineHandle
            gapIndex={index}
            key={leftHandleId}
            {...{ onDragStart, onDragStop }}
          />,
        );

        if (index === timeline.length - 1) {
          elements.push(
            <FramingTimelineHandle
              gapIndex={timeline.length}
              key={rightHandleId}
              {...{ onDragStart, onDragStop }}
            />,
          );
        }
        return elements;
      }, [])}
    </>
  );
}
